import { render, staticRenderFns } from "./ai-chat-dialog.vue?vue&type=template&id=88c67a72&scoped=true"
import script from "./ai-chat-dialog.vue?vue&type=script&lang=js"
export * from "./ai-chat-dialog.vue?vue&type=script&lang=js"
import style0 from "./ai-chat-dialog.vue?vue&type=style&index=0&id=88c67a72&prod&lang=scss&scoped=true"
import style1 from "./ai-chat-dialog.vue?vue&type=style&index=1&id=88c67a72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c67a72",
  null
  
)

export default component.exports